import { FleekError } from './FleekError';

type ValidationErrorOptions = Record<string, string>;

export class ValidationError extends FleekError<ValidationErrorOptions> {
  public name = 'ValidationError';

  toString = () => `${JSON.stringify(this.data)}`;
}
